import { Table, TableContainer } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { sectionGap, stackedClassName } from './mdConsts';

const MDTable: React.FC<PropsWithChildren> = ({ children = null }) => (
	<TableContainer
		data-testid="md-table"
		sx={{
			[`:not(.${stackedClassName} > &)`]: {
				mt: sectionGap
			}
		}}
	>
		<Table size="small">{children}</Table>
	</TableContainer>
);

export default MDTable;
